<template>
  <div class="accommodation">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <a href="javascript:void(0)" class="menu-link text-center text-bold" :class="(currentTemplateNature === 'email') ? 'active' : ''" @click="currentTemplateType='EmailTemplate'; currentTemplateNature='email'">
                    Email
                </a>
            </div>
            <div class="col-md-4">
                <a href="javascript:void(0)" class="menu-link text-center text-bold" :class="(currentTemplateNature === 'sms') ? 'active' : ''" @click="currentTemplateType='SmsTemplate'; currentTemplateNature='sms'">
                    Sms
                </a>
            </div>
        </div>
    </div>
    <hr/>
    <div class="row mt-3">
      <div class="col-md-12">
          <component :is="currentTemplateType" />
      </div>
    </div>

  </div>
</template>
  
  <script>
  import 'datatables.net'
  import 'datatables.net-select'
  import VdtnetTable from 'vue-datatables-net'
  import EmailTemplate from '../../components/Templates/EmailTemplate.vue'
  import SmsTemplate
   from '../../components/Templates/SmsTemplate.vue'
  export default {
    name: 'EmailtemplateIndex',
    components: {
      VdtnetTable,
      EmailTemplate,
      SmsTemplate
    },
    data() {
      return {
        currentTemplateType:'EmailTemplate',
        currentTemplateNature:'email',
      }
    },
    methods: {
      
    }
  }
  
</script>
<style scoped>
.menu-link {
  display: block;
  height: 60px;
  padding: 15px 20px;
  border-radius: 5px;
  text-decoration: none;
  color: #000;
  background-color: #fff;
  border: 1px solid #dee2e6;
  font-size: 18px;
  font-weight: bold;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.menu-link.active {
  background-color: #fd7e14;
  color: #fff;
  border: 1px solid #fd7e14;
}
</style>